import { render, staticRenderFns } from "./userOfCourses.vue?vue&type=template&id=60ee2972&"
import script from "./userOfCourses.vue?vue&type=script&lang=js&"
export * from "./userOfCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports